import { ErrorMessage } from '~/components/error-message';
import { Link } from '~/components/link';
import { amerenRedirectUrl } from '~/utils/redirects';

export const AmerenSignup = ({ error }: { error?: string }) => (
  <>
    <ErrorMessage error={error} mb={2} />
    <Link color="primaryInverse" fullWidth hideIcon href={amerenRedirectUrl()} type="CTA">
      Authorize with Ameren
    </Link>
  </>
);
